<template>
  <nav class="navbar navbar-inverse">
    <div class="container-fluid">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navmenu" aria-expanded="false">
          <span class="sr-only">Trocar Modo de Navegação</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a href="#"><img class="img-responsive" src="../assets/ifpelogo.png"></a>
      </div>
      <div class="collapse navbar-collapse" id="navmenu">
        <ul class="nav navbar-nav">
          <li v-if="loggedUser"><router-link to="/userProfile" id="menu-open-request">Minhas Requisições</router-link></li>
          <li v-if="loggedUser"><router-link to="/openRequest" id="menu-open-request">Abrir Requisição</router-link></li>
          <li v-if="loggedUser && adminUser"><router-link to="/management" id="menu-admin">Administração</router-link></li>
        </ul>
        <ul class="nav navbar-nav navbar-right">
          <li v-if="!loggedUser">
            <router-link to="/login"><span class="glyphicon glyphicon-log-in"></span> Entrar</router-link>
          </li>
          <li v-if="loggedUser">
            <router-link id="welcome-menu-item" to="/userProfile" title="Clique ver seu perfil">Bem-vindo, {{ loggedUser.get('name') }} <span class="badge badge-notifications">{{ numberOfLinkedRequests }}</span></router-link>
          </li>
          <li v-if="loggedUser">
            <router-link to="/login?ex=1" @click.native="logout" id="btn-logout"><span class="glyphicon glyphicon-off"></span> Sair</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>

  import {
    Parse,
    GlobalChannel
  } from '../Global'
  import { handleParseError } from './util/ErrorHandling'
  import { PUBLIC_URL } from '../../config/prod.env'
  
  var publicURL = JSON.parse(PUBLIC_URL)

  export default {
    data () {
      return {
        adminUser: false,
        loggedUser: Parse.User.current(),
        numberOfLinkedRequests: 0
      }
    },
    mounted () {
      let self = this
      GlobalChannel.$on('loginSuccess', function () {
        self.loggedUser = Parse.User.current()
        self.loadNavbarAttributes()
      })
      self.loadNavbarAttributes()
    },
    methods: {
      logout () {
        let self = this
        if (self.loggedUser.getEmail() !== self.loggedUser.getUsername()) {
          location.href = `https://acesso.ifpe.edu.br/realms/master/protocol/openid-connect/logout?redirect_uri=${publicURL}`
        }
        Parse.User.logOut()
        this.loggedUser = null
        this.adminUser = false
        this.numberOfLinkedRequests = 0
      },
      loadNavbarAttributes () {
        if (Parse.User.current()) {
          let self = this
          let params = {
            currentPage: 1,
            perPage: 1,
            filter: ''
          }
          Parse.Cloud.run('listInvitedRequests', params).then(function (results) {
            self.numberOfLinkedRequests = results.total
            let queryRole = new Parse.Query(Parse.Role)
            queryRole.equalTo('users', self.loggedUser)
            queryRole.containedIn('name', ['ADMIN_REQUESTS', 'ADMIN_REQTYPE', 'ADMIN_WORKFLOW', 'ADMIN_GROUPS', 'ADMIN_USERS'])
            return queryRole.count()
          }).then(function (count) {
            self.adminUser = count > 0
          }, function (error) {
            handleParseError(self, error)
          })
        }
      }
    }
  }

</script>

<style scoped lang="scss">
.navbar {
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0 !important;
}
.badge-notifications {
  background-color: lighten(red, 10%) !important;
}
</style>




// WEBPACK FOOTER //
// Navbar.vue?247c39a8